export default class Toast {
	private static container: HTMLDivElement;
	
	public static init() {
		if (!Toast.container) {
			Toast.container = document.createElement('div');
			Toast.container.id = 'toast-container';
			document.body.appendChild(Toast.container);
		}
	}
	
	public static show(message: string, type: 'success' | 'error' | 'info' = 'info', duration: number = 3000, action?: { label: string; onClick: () => void }) {
		Toast.init();
		
		const toast = document.createElement('div');
		toast.className = `toast toast-${type}`;
		
		const text = document.createElement('span');
		text.innerText = message;
		toast.appendChild(text);
		
		if (action) {
			const actionBtn = document.createElement('button');
			actionBtn.textContent = action.label;
			actionBtn.className = 'toast-action-btn';
			actionBtn.onclick = () => { action.onClick(); Toast.remove(toast); };
			toast.appendChild(actionBtn);
		}
		
		const closeBtn = document.createElement('button');
		closeBtn.innerHTML = '&times;';
		closeBtn.className = 'toast-close-btn';
		closeBtn.onclick = () => { Toast.remove(toast); }
		toast.appendChild(closeBtn);
		
		Toast.container.appendChild(toast);
		
		// Auto remove
		if (duration > 0) {
			setTimeout(() => { Toast.remove(toast); }, duration);
		}
	}
	
	private static remove(toast: HTMLDivElement) {
		toast.classList.add('toast-fading-out');
		
		toast.addEventListener('animationend', () => {
			if (toast.parentElement) {
				toast.parentElement.removeChild(toast);
			}
		});
	}
}

window.Toast = Toast;
